import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons/faInfoCircle';

import React from 'react';
import { Tooltip } from 'ui-components/components/tooltip';
import { TooltipContent } from 'ui-components/components/tooltip/tooltip-content';
import { FormattedMessage } from 'react-intl';

import style from './package-insurance.module.css';
import { messages } from './messages';

export const DisabledWithToolTip = () => {
  return (
    <Tooltip position='bottom'>
      <div className={style['error-icon']}>
        <FontAwesomeIcon icon={faInfoCircle} />
      </div>
      <TooltipContent>
        <FormattedMessage {...messages.insuranceTooltipContent} />
      </TooltipContent>
    </Tooltip>
  );
};
